// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2w8W5","label":"Category_label__2U3UQ","content":"Category_content__3fHNP","header":"Category_header__2dDM6","location":"Category_location__1S_4A"};